export default __webpack_public_path__ + "static/media/user-testing-template.c37a3976.pdf";